import BaseStore from "@/v1/utils/BaseStore";

const initialState = {};
const store = new BaseStore("bonusReport", initialState);

const reducer = {};

export default store.reducer(reducer);
